import {clone, indexOf, isNil, last} from 'ramda';

import {
  DrillDownResponse,
  DrillDownLevelName,
  DrillDownStatistics,
  RawDrillDownResponse,
} from '../types';

const OPTIONAL_LEVELS: DrillDownLevelName[] = ['vat_reclaimable', 'trim_level', 'number_of_seats'];
const OTHER_LEVEL_VALUE = 'other';

// TODO T20-30972 - fix response on BE
export function fixAlfaBugsInDrillDownResponse(
  requestLevelNames: DrillDownLevelName[],
  response: RawDrillDownResponse
): DrillDownResponse {
  const clonedResponse = clone(response);

  // this is bug in Alfa (levels in response are not sorted by request levels)
  clonedResponse.statisticsAggregated.forEach((item) => {
    // Alfa omits levels whose aggregated value is null. Keep their statistics in an Other row.
    requestLevelNames
      .filter((name) => OPTIONAL_LEVELS.includes(name))
      .forEach((name) => {
        const level = item.levels.find((candidate) => candidate.name === name);
        if (isNil(level)) {
          item.levels.push({name, value: OTHER_LEVEL_VALUE});
        } else if (isNil(level.value)) {
          level.value = OTHER_LEVEL_VALUE;
        }
      });
    item.levels.sort(
      (a, b) => indexOf(a.name, requestLevelNames) - indexOf(b.name, requestLevelNames)
    );
  });

  // this is bug in Alfa (there is missing level in response against request)
  const statisticsAggregated = clonedResponse.statisticsAggregated
    .filter((item) => last(requestLevelNames) === last(item.levels)?.name)
    .filter((item): item is DrillDownStatistics =>
      item.levels.every((level) => !isNil(level.value))
    );

  return {...clonedResponse, statisticsAggregated};
}
